export const ACCOUNTING_CONNECTION_SERVICE_VALUES = [
    'quickbooks',
    'xero',
    'netsuite',
    'intacct',
    'manual',
    'quickbooks_webconnector'
];
export var ACCOUNTING_CONNECTION_STATE_TYPES;
(function (ACCOUNTING_CONNECTION_STATE_TYPES) {
    ACCOUNTING_CONNECTION_STATE_TYPES["ACTIVE"] = "active";
    ACCOUNTING_CONNECTION_STATE_TYPES["CANCELED"] = "canceled";
    ACCOUNTING_CONNECTION_STATE_TYPES["ERROR"] = "error";
    ACCOUNTING_CONNECTION_STATE_TYPES["DELETED"] = "deleted";
    ACCOUNTING_CONNECTION_STATE_TYPES["PENDING"] = "pending";
})(ACCOUNTING_CONNECTION_STATE_TYPES || (ACCOUNTING_CONNECTION_STATE_TYPES = {}));
export const ACCOUNTING_CONNECTION_STATE_VALUES = [
    ACCOUNTING_CONNECTION_STATE_TYPES.ACTIVE,
    ACCOUNTING_CONNECTION_STATE_TYPES.CANCELED,
    ACCOUNTING_CONNECTION_STATE_TYPES.ERROR,
    ACCOUNTING_CONNECTION_STATE_TYPES.DELETED,
    ACCOUNTING_CONNECTION_STATE_TYPES.PENDING
];
export var ACCOUNTING_CONNECTION_PROVIDER_TYPES;
(function (ACCOUNTING_CONNECTION_PROVIDER_TYPES) {
    ACCOUNTING_CONNECTION_PROVIDER_TYPES["SPEND"] = "spend";
    ACCOUNTING_CONNECTION_PROVIDER_TYPES["ERP_GATEWAY"] = "erp_gateway";
})(ACCOUNTING_CONNECTION_PROVIDER_TYPES || (ACCOUNTING_CONNECTION_PROVIDER_TYPES = {}));
export const ACCOUNTING_CONNECTION_PROVIDER_TYPE_VALUES = [
    ACCOUNTING_CONNECTION_PROVIDER_TYPES.SPEND,
    ACCOUNTING_CONNECTION_PROVIDER_TYPES.ERP_GATEWAY
];
export var ACCOUNTING_CONNECTION_EXPENSE_SYNC_TYPES;
(function (ACCOUNTING_CONNECTION_EXPENSE_SYNC_TYPES) {
    ACCOUNTING_CONNECTION_EXPENSE_SYNC_TYPES["EXPENSE_BATCH"] = "expense_batch";
    ACCOUNTING_CONNECTION_EXPENSE_SYNC_TYPES["CORPORATE_CARD"] = "corporate_card";
})(ACCOUNTING_CONNECTION_EXPENSE_SYNC_TYPES || (ACCOUNTING_CONNECTION_EXPENSE_SYNC_TYPES = {}));
export const ACCOUNTING_CONNECTION_EXPENSE_SYNC_TYPE_VALUES = [
    ACCOUNTING_CONNECTION_EXPENSE_SYNC_TYPES.EXPENSE_BATCH,
    ACCOUNTING_CONNECTION_EXPENSE_SYNC_TYPES.CORPORATE_CARD
];
